import React from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { usePermissions } from "layouts/Admin";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import TranslationViewTable from "./ClientTranslationViewTable";
import FullPageLoader from "components/common/FullPageLoader";
import { getClientTranslationById } from "slices/mainAccount/ClientTranslationSlice";
import TransLogsTable from "views/Translation/TransLogsTable";
import QuotationsTable from "views/Translation/QuotationsTable";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { rejectQuote } from "slices/mainAccount/ClientTranslationSlice";
import { approveQuote } from "slices/mainAccount/ClientTranslationSlice";
import CancelModal from "components/appointment/CancelModal";
import { clientCancelTranslation } from "slices/mainAccount/ClientTranslationSlice";
import { ViewQuotationModal } from "views/Translation/ViewQuotationModal";
import TranslatedDocumentsTable from "./TranslatedDocumentsTable";
import ClientInvoiceTable from "./ClientInvoiceTable";

const ClientTranslationView = () => {
  const { id } = useParams();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [parentItem, setParentItem] = React.useState({});
  const [selectedProjectId, setSelectedProjectId] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelTranslator, setCancelTranslator] = React.useState(false);
  const [quotationView, setQuotationView] = React.useState({
    show: false,
    id: null,
  });

  // const [cotationPopup, setCotationPopup] = React.useState({
  //   open: false,
  //   documents: [],
  // });

  const callViewApi = async (projectId = id) => {
    const callBack = (success, data) => {
      setLoading(false);
      if (success) {
        // setItem(data);
        setParentItem(data);

        // const selectedChild = data?.parent_project_links?.find(
        //   (link) => String(link?.child_translation?.id) === String(selectedProjectId)
        // )?.child_translation;
        // setItem(selectedChild || data);

        const currentProject = data?.current_project || data;
        setItem(currentProject);
        setSelectedProjectId(
          currentProject?.id && String(currentProject.id) !== String(data?.id)
            ? currentProject.id
            : null
        );
      } else {
        setParentItem({});
        setItem({});
        setSelectedProjectId(null);
      }
    };
    dispatch(getClientTranslationById(projectId, callBack));
  };

  const selectProject = (project) => {
    const isParent = String(project?.id) === String(parentItem?.id);
    setLoading(true);
    callViewApi(isParent ? parentItem.id : project.id);
  };

  //   fetch logs
  // const fetchLogs = async () => {
  //   const callBack = (success, message, data) => {
  //     if (success) {
  //       setLogs(data);
  //       console.log("data", data);
  //     } else {
  //       console.log("res", message);
  //     }
  //   };
  //   dispatch(getTransLogs(id, callBack));
  // };

  const openQuotationView = (qId) =>
    setQuotationView({
      show: true,
      id: qId,
    });

  React.useEffect(() => {
    if (id) {
      setLoading(true);
      callViewApi();
      // fetchLogs();
    }
  }, [id]);

  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const rawDatetime = item?.created_at;
  console.log("item", item);
  const formattedDate = moment(rawDatetime, "YYYY-MM-DD HH:mm:ss").format(
    "MMM D, YYYY HH:mm:ss"
  );

  const handleCloseCancelTranslator = () => {
    setCancelTranslator(false);
  };

  const onApprove = () => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure, you want to approve it?",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      customClass: {
                cancelButton: 'main_button  tomatoRed',
                confirmButton: 'swal-btn',
            },
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        setLoading(true);
        const callBack = (success) => {
          if (success) {
            toast.success("Approved Successfully ", {
              className: "successToast",
            });
            callViewApi(selectedProjectId || id);
          }
        };
        dispatch(approveQuote(item?.id, callBack));
      }
    });
  };

  const onReject = () => {
    Swal.fire({
      title: "Reason For Rejection",
      // text: "Are you sure, you want to reject it?",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      input: "text",
      inputPlaceholder: "Write here Reason for Rejection",
      inputValidator: (value) => {
        if (!value) {
          return "You need to write something!";
        }
      },
    }).then(({ isConfirmed, value }) => {
      if (isConfirmed) {
        const callBack = (success) => {
          if (success) {
            toast.success("Rejected Successfully ", {
              className: "successToast",
            });
            callViewApi(selectedProjectId || id);
          }
        };
        const data = {
          rejection_reason: value,
        };
        setLoading(true);
        dispatch(rejectQuote(item?.id, data, callBack));
      }
    });
  };

  const handleCancelTranslator = () => {
    setCancelTranslator(true);
  };

  // Client Cancel Translation
  const onCancelTranslation = (data) => {
    setLoading(true);
    const callBack = (success) => {
      console.log("succ", success);
      if (success) {
        toast.success("Cancelled Successfully", {
          className: "successToast",
        });
        callViewApi(selectedProjectId || id);
        handleCloseCancelTranslator();
      } else {
      }
    };
    dispatch(clientCancelTranslation(data, id, callBack));
  };

  console.log("itemssss", item?.status);

   const statusMap = {
    "Translators Invited": "Invited",
    "Invoice Sent": "Submission Approved",
    "Client Cancelled": "Cancelled",
    "Quote Sent": "Quote Received",
  };

  
  return (
    <div className="content" style={{}}>
      {quotationView.show && (
        <ViewQuotationModal
          itemId={quotationView?.id}
          item={item}
          show={quotationView.show}
          onClose={() => setQuotationView({ show: false, id: null })}
        />
      )}

      <CancelModal
        isOpen={cancelTranslator}
        onClose={handleCloseCancelTranslator}
        onConfirm={onCancelTranslation}
        appointmentId={id}
        item={item}
        loader={loading}
        heading="Project"
        showAppId={false}
      />

      {loading && <FullPageLoader />}
      {/* {parentItem?.parent_project_links?.length > 0 && (
        <div className="row-primary flex-wrap mb-3" role="tablist" aria-label="Linked project phases">
          <SubmitButton
            buttonType="button"
            className={!selectedProjectId ? "main_button" : "lightGrey"}
            btnText={
              parentItem?.translation_details?.current_phase
                ? parentItem.translation_details.current_phase
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (letter) => letter.toUpperCase())
                : "Parent"
            }
            handleSubmit={() => selectProject(parentItem)}
          />
          {parentItem.parent_project_links.map((link) => {
            const child = link?.child_translation;
            const phase = child?.translation_details?.current_phase;
            if (!child || !phase) return null;
            const phaseLabel = phase
              .replace(/_/g, " ")
              .replace(/\b\w/g, (letter) => letter.toUpperCase());
            return (
              <SubmitButton
                key={child.id}
                buttonType="button"
                className={String(selectedProjectId) === String(child.id) ? "main_button" : "lightGrey"}
                btnText={phaseLabel}
                handleSubmit={() => selectProject(child)}
              />
            );
          })}
        </div>
      )} */}
      <div className="row_main_head bg-primary-secondaryCard">
        <h2 className={`main_heading main_heading1 mb-3`}>
          project job #{item?.transid}
        </h2>
        <h2 className={`main_heading main_heading1 mb-3`}>
          Client : #{item?.accounts?.user?.name || "N/A"}
        </h2>
      </div>
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2`} toLowerCase={"text-lowercase"}>
          Date & Time <span className="dateTime">{formattedDate}</span>
        </h2>

        <div className="mb-3">
          <div className="text-transform-capitalize main_heading2">
            <span className="appLanguage"> {statusMap[item.status] || item.status}</span>
          </div>
        </div>
      </div>
      
      {parentItem?.parent_project_links?.length > 0 && (
        <div className="translation-tab-div" role="tablist" aria-label="Linked project phases">
          <SubmitButton
            buttonType="button"
            className={!selectedProjectId ? "active main_button" : "lightGrey"}
            btnText={
              parentItem?.translation_details?.current_phase
                ? parentItem.translation_details.current_phase
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (letter) => letter.toUpperCase())
                : "Parent"
            }
            handleSubmit={() => selectProject(parentItem)}
          />
          {parentItem.parent_project_links.map((link) => {
            const child = link?.child_translation;
            const phase = child?.translation_details?.current_phase;
            if (!child || !phase) return null;
            const phaseLabel = phase
              .replace(/_/g, " ")
              .replace(/\b\w/g, (letter) => letter.toUpperCase());
            return (
              <SubmitButton
                key={child.id}
                buttonType="button"
                className={String(selectedProjectId) === String(child.id) ? "active main_button" : "lightGrey"}
                btnText={phaseLabel}
                handleSubmit={() => selectProject(child)}
              />
            );
          })}
        </div>
      )}

      <div className={ parentItem?.parent_project_links?.length > 0 ?"translation-detail card_table view_table_custom" : "card_table view_table_custom"}>
        {mileageCheck("extra_mileage") &&
        mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>The vendor has requested extra mileage</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="View Request"
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              The extra mileage request for this appointment have been approved.
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              The extra mileage request for this appointment have been rejected.
            </h3>
          </div>
        ) : (
          ""
        )}

        {item.status !== "Client Cancelled" &&
          item.status !== "Cancelled" &&
          item.status !== "Completed" && (
            <SubmitButton
              buttonType="button"
              className={"tomatoRed"}
              btnText="Cancel Project"
              handleSubmit={handleCancelTranslator}
            />
          )}

        <TranslationViewTable item={item} />
      </div>

      {/* {item && item?.translation_translated_files?.length > 0 && (
              <>
                <div className="card_table p-4">
                  <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Translated Documents</h2>
                  </div>
                  <TranslatedDocumentsTable
                    item={item}
                    callViewApi={callViewApi}
                  />
                </div>
              </>
            )} */}

      {/* {item && item?.translation_invoices && (
        <>
          <div className="card_table p-4">
            <div className="row_main_head mb-3">
              <h2 className={`main_heading`}>Invoice</h2>
            </div>
            <ClientInvoiceTable
              item={item}
              // onMarkInvoiceAsPaid={onMarkInvoiceAsPaid}
            />
          </div>
        </>
      )} */}

      {item?.translation_translated_files?.length > 0 &&
        item?.status === "Completed" && (
          <>
            <div className="card_table p-4">
              <div className="row_main_head mb-3">
                <h2 className={`main_heading`}>Translated Documents</h2>
              </div>
              <TranslatedDocumentsTable
                item={{
                  ...item,
                  translation_translated_files: [
                    [...item.translation_translated_files].sort(
                      (a, b) => new Date(b.created_at) - new Date(a.created_at)
                    )[0],
                  ],
                }}
                callViewApi={callViewApi}
              />
            </div>
          </>
        )}

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Original Documents</h2>
        </div>
        <TransLogsTable item={item} />
      </div>
      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Quotations History</h2>
          {/* <SubmitButton
            handleSubmit={() => setCotationPopup({ open: true, documents: [] })}
            btnText="Revise Quote"
            className="main_button"
          /> */}
        </div>

        {/* Quotation Table  */}
        <QuotationsTable
          item={item}
          onApprove={onApprove}
          onReject={onReject}
          onView={openQuotationView}
        />
      </div>
      {/* <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Translation Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div> */}
    </div>
  );
};

export default ClientTranslationView;
